import { render, staticRenderFns } from "./platformViewNew.vue?vue&type=template&id=f64fe5ce&scoped=true"
import script from "./platformViewNew.vue?vue&type=script&lang=js"
export * from "./platformViewNew.vue?vue&type=script&lang=js"
import style0 from "./platformViewNew.vue?vue&type=style&index=0&id=f64fe5ce&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f64fe5ce",
  null
  
)

export default component.exports